import Component from '../abstracts/Component';
import Cookies from 'js-cookie';

export default class LoginPopupComponent extends Component {

  get COMPONENTNAME() {
      return 'LoginPopupComponent';
  }

  get COOKIE_NAME() {
    return 'login_popup_hide';
  }

  // MILLISECONDS //
  get TIMER() {
    return {
      start: 3000,
      end: 8000
    }
  }

  get SELECTORS() {
    return {
      main: '.c-login-popup',
      href: '[data-href]',
      headerAccountIcon: '[data-componentpb="AccountLayerComponent"]',
      headerCartIcon: '[data-componentpb="CartLayerComponent SimpleBarComponent"]',
    };
  }

  constructor(elem) {
    super(elem);
  }

  readDOM() {
    return {
      main: document.querySelector(this.SELECTORS.main),
      href: document.querySelector(this.SELECTORS.href),
      starTimerID: '',
      endTimerID: ''
    }
  }

  render() {
    this.log("Rendering...");

    //cookie does not exists yet
    if(!this.getCookie()) {
      this.dom = this.readDOM();
      this.bindEvents();
      this.showTimer();
    }
  }

  // EVENT LISTENERS //
  bindEvents() {
    // HANDLE POPUP REDIRECT ON CLICK //
    if(this.dom.href.dataset.href) {
      this.dom.href.addEventListener('click', (event) => {
        // link inside text popup has been clicked ==> skip redirect //
        if(event.target.tagName !== 'A') {
          window.location.href = this.dom.href.dataset.href;
        }
      });
    }
    // HANDLE SCROLL POSITION //
    document.addEventListener("scroll", (event) => {
      let scrollHeight = document.body.scrollHeight;
      if(window.scrollY > scrollHeight/2) {
        this.showPopup(false);
      }
    });
    // HANDLE MY ACCOUNT HOVER //
    let headerAccountIcon = document.querySelector(this.SELECTORS.headerAccountIcon);
    if(headerAccountIcon) {
      headerAccountIcon.addEventListener("mouseover", (event) => {
        this.setCookie();
        this.showPopup(false);
      });
      headerAccountIcon.addEventListener("click", (event) => {
        this.setCookie();
        this.showPopup(false);
      });
    }
    // HANDLE QUICK CART HOVER //
    let headerCartIcon = document.querySelector(this.SELECTORS.headerCartIcon);
    if(headerCartIcon) {
      headerCartIcon.addEventListener("mouseover", (event) => {
        this.setCookie();
        this.showPopup(false);
      });
      headerCartIcon.addEventListener("click", (event) => {
        this.setCookie();
        this.showPopup(false);
      });
    }
  }

  // FUNCTIONS //
  showTimer() {
    this.dom.starTimerID =
      setTimeout( () => {
        this.showPopup(true);
        this.hideTimer();
      }, this.TIMER.start);
  }

  hideTimer() {
    this.dom.endTimerID = setTimeout( () => {
      this.showPopup(false);
      this.setCookie();
    }, this.TIMER.end);
  }

  // UTILS //
  showPopup(isVisible) {
    if(this.dom.main != null) {
      isVisible ? this.dom.main.classList.remove('d-none') : this.dom.main.classList.add('d-none');
    }
  }

  setCookie() {
    Cookies.set(this.COOKIE_NAME, 'true');
    this.dom.starTimerID ? clearTimeout(this.dom.starTimerID) : '';
    this.dom.sendTimerID ? clearTimeout(this.dom.sendTimerID) : '';
  }

  getCookie() {
    return Cookies.get(this.COOKIE_NAME);
  }
}
